import React from 'react';

export const Menu: React.FC<{
    children: any;
    width?: string;
    height?: string;
}> = ({ children, width = 'auto', height = 'auto' }) => {
    const setStyle = {
        width: `${width}`,
        height: `${height}`,
    };

    return (
        <>
            <div
                className='menuContainer'
                style={setStyle}
            >
                {children}
            </div>
        </>
    );
};
